// extracted by mini-css-extract-plugin
export var contactInfo = "PageFooter-module--contactInfo--5mBPT";
export var container = "PageFooter-module--container--dvaLH";
export var footer = "PageFooter-module--footer--JQwy7";
export var prompt = "PageFooter-module--prompt--IaEHd";
export var sectionsList = "PageFooter-module--sectionsList--gopTu";
export var socialLinks = "PageFooter-module--socialLinks--k9rDT";
export var title = "PageFooter-module--title--pnCEF";